<template>
  <div class="create-bill-root">
    <div class="bill-title" v-if="serviceType == 'repair'">维修订单</div>
    <div class="bill-title" v-else-if="serviceType == 'maintenance'">保养订单</div>
    <div class="bill-title" v-else-if="serviceType == 'inspection'">检查订单</div>
    <div class="bill-title" v-else-if="serviceType == 'wash'">洗车订单</div>
    <div class="bill-title" v-else-if="serviceType == 'vme'">车载维护订单</div>
    <div class="bill-title" v-else-if="serviceType == 'assess'">定损订单</div>

    <div class="vehicle-info">
      <span class="info-item"><span class="info-label">车牌号：</span>{{ bill.vehicleNo }}</span>
      <span class="info-item"><span class="info-label">车型：</span>{{ bill.brand }}</span>
      <span class="info-item"><span class="info-label">驾驶员：</span>{{ bill.driverNo }}</span>
    </div>

    <el-form :model="bill" label-width="100px" class="bill-form">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="服务商">
            <el-select v-model="bill.providerId" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in providers" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经手人">
            <span class="form-readonly">{{ bill.staffName || '—' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="截至时间">
            <el-date-picker v-model="bill.billDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
              style="width: 100%" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="车载类目" v-if="serviceType == 'vme'">
        <el-select v-model="bill.serviceProjs" multiple placeholder="请选择" style="width: 100%">
          <el-option v-for="item in vmeProjs" :key="item.value" :label="item.name" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="维修类目" v-if="serviceType == 'repair'">
        <el-select v-model="bill.serviceProjs" multiple placeholder="请选择" style="width: 100%">
          <el-option v-for="item in repairProjs" :key="item.value" :label="item.name" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="损耗件类目" v-if="serviceType == 'consumables'">
        <el-select v-model="bill.serviceProjs" multiple placeholder="请选择" style="width: 100%">
          <el-option v-for="item in consumablesProjs" :key="item.value" :label="item.name" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item label="备注">
        <el-input v-model="bill.remark" type="textarea" :rows="3" placeholder="请输入备注" />
      </el-form-item>
      <el-form-item label="创建原因说明">
        <el-input v-model="bill.createReason" type="textarea" :rows="3" placeholder="请输入创建原因说明" />
      </el-form-item>
    </el-form>

    <div class="dialog-footer">
      <el-button @click="cancelBill">取消</el-button>
      <el-button type="primary" @click="saveBill">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getPartnerProviderList, getServiceProjs } from "@/api/partner_admin.js";
export default {
  name: "create-bill",
  props: {
    vehicleInfo: {
      type: Object
    },
    serviceType: {
      type: String
    }
  },
  data() {
    return {
      bill: {
        vehicleNo: null,
        brand: null,
        color: null,
        driverNo: null,
        driverName: null,
        privoderId: null,
        privoderName: null,
        staffName: null,
        billDate: null,
        serviceType: null,
        serviceProjs: [],
        remark: "",
        createReason: ""
      },
      providers: [],
      repairProjs: [],
      vmeProjs: [],
      consumablesProjs: []
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.bill.vehicleNo = this.vehicleInfo.vehicleNo;
      this.bill.brand = this.vehicleInfo.brand;
      this.bill.color = this.vehicleInfo.color;
      this.bill.driverNo = this.vehicleInfo.driverNo;
      this.bill.driverName = this.vehicleInfo.driverName;
      let serviceType = this.serviceType;
      getPartnerProviderList({}).then((rs) => {
        let data = rs.data || {};
        let providers = data.providers || [];
        this.providers = providers.filter((p) => p.svcScopes.indexOf(serviceType) >= 0);
        if (this.providers.length == 1) {
          this.bill.providerId = this.providers[0].id;
          this.bill.providerName = this.providers[0].name;
        }
      });
      getServiceProjs().then((rs) => {
        let data = rs.data || {};
        this.repairProjs = data.repair || [];
        this.vmeProjs = data.vme || [];
        this.consumablesProjs = data.consumables || [];
      });
    },
    saveBill() {
      this.bill.serviceType = this.serviceType;
      if (!this.bill.providerId) {
        this.$message.error("请选择服务商。");
        return;
      }
      if (!this.bill.billDate) {
        this.$message.error("维修截至时间必填。");
        return;
      }
      this.$emit("billChange", { bill: this.bill, action: "save" });
    },
    cancelBill() {
      this.$emit("billChange", { bill: this.bill, action: "cancel" });
    }
  }
};
</script>

<style scoped lang="less">
.create-bill-root {
  padding: 0 4px;

  .bill-title {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
    color: #303133;
  }

  .vehicle-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    margin-bottom: 20px;
    background: #f5f7fa;
    border-radius: 4px;

    .info-item {
      flex: 1;
      text-align: center;
      font-size: 14px;
      color: #606266;

      .info-label {
        color: #909399;
        margin-right: 4px;
      }

      &:not(:last-child) {
        border-right: 1px solid #e4e7ed;
      }
    }
  }

  .bill-form {
    margin-bottom: 20px;

    .form-readonly {
      display: inline-block;
      line-height: 32px;
      color: #606266;
      font-size: 14px;
    }
  }

  .dialog-footer {
    text-align: right;
    padding-top: 12px;
    border-top: 1px solid #ebeef5;

    .el-button+.el-button {
      margin-left: 10px;
    }
  }
}
</style>
